import styled from 'styled-components';

export default styled.div`
	--gm-grid: 1fr 1fr 1fr 1fr 1fr 1fr;
	--gap: 2rem;
	display: flex;
	flex-direction: column;
	.message-type {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-medium);
	}
	.contact {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-medium);
	}
`;
